<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0 font-size-18">{{ title }}</h4>

        <div class="page-title-right">
          <b-breadcrumb :items="enrichedBreadcrumbs" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
import i18n from "@/i18n";
import { toastrService } from '@/helpers/services/notification/toastrService';

const DASHBOARD_BREADCRUMB = {text: i18n.t('menuitems.dashboard.text'), href: "/"};
const DEFAULT_CURRENT_BREADCRUMB = {text: "", active: true};

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    breadcrumbs: {
      type: Array,
    },
    toastrMessage: {
      type: String,
    },
    toastrType: {
      type: String,
    },
  },
  data() {
    return {
      enrichedBreadcrumbs: [],
    }
  },
  methods: {
    /**
     * Make sure that breadcrumb "home" is always clickable
     */
    enrichBreadcrumbs(breadcrumbs) {
      // If no breadcrumbs are set, do nothing at leave default value
      if (!breadcrumbs || breadcrumbs.length < 1) {
        return [DASHBOARD_BREADCRUMB, DEFAULT_CURRENT_BREADCRUMB];
      }

      // If first breadcrumb is already linked to "home", everyhting is fine
      if (breadcrumbs[0].href === "/") {
        return breadcrumbs;
      }

      // If first breadcrumb is not linked to "home", do so
      breadcrumbs.unshift(DASHBOARD_BREADCRUMB);
      return breadcrumbs;
    },
    showToastrMessage(toastrType, toastrMessage) {
      switch (toastrType) {
        case toastrService.ERROR_TYPE:
          toastrService.showError(toastrMessage);
          break;
        case toastrService.SUCCESS_TYPE:
          toastrService.showSuccess(toastrMessage);
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.enrichedBreadcrumbs = this.enrichBreadcrumbs(this.breadcrumbs);
    this.showToastrMessage(this.toastrType, this.toastrMessage);
  }
}
</script>